// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"0a1c0348","832":"784721b0","990":"e9dfa9d5"}[chunkId] + ".chunk.js";
};